import { PRODUCT_TYPE_BOATS_INFLATABLES_KEY, PRODUCT_TYPE_BOATS_KEY, PRODUCT_TYPE_BOATS_YAM_KEY, PRODUCT_TYPE_EBIKE_KEY, PRODUCT_TYPE_EBIKES_KEY, PRODUCT_TYPE_MARINE_ENGINE_KEY, PRODUCT_TYPE_MARINE_ENGINES_KEY, PRODUCT_TYPE_MOTORCYCLE_KEY, PRODUCT_TYPE_MOTORCYCLES_KEY, PRODUCT_TYPE_SCOOTER_KEY, PRODUCT_TYPE_SCOOTERS_KEY, } from '@yme/selectors/constants';
import { getUpperCasedValueForProductType } from '@yme/utils/product';
export const checkProductTypeEqual = (currentProductType = '', typeVariants = []) => {
    return (Boolean(currentProductType) &&
        typeVariants.some((item) => {
            return Boolean(getUpperCasedValueForProductType(currentProductType) ===
                getUpperCasedValueForProductType(item));
        }));
};
export const checkBoatsProductType = (currentProductType) => {
    return checkProductTypeEqual(currentProductType, [
        PRODUCT_TYPE_BOATS_KEY,
        PRODUCT_TYPE_BOATS_INFLATABLES_KEY,
        PRODUCT_TYPE_BOATS_YAM_KEY,
    ]);
};
export const checkMotorcyclesProductType = (currentProductType) => {
    return checkProductTypeEqual(currentProductType, [
        PRODUCT_TYPE_MOTORCYCLE_KEY,
        PRODUCT_TYPE_MOTORCYCLES_KEY,
    ]);
};
export const checkEBikesProductType = (currentProductType) => {
    return checkProductTypeEqual(currentProductType, [
        PRODUCT_TYPE_EBIKE_KEY,
        PRODUCT_TYPE_EBIKES_KEY,
    ]);
};
export const checkScooterProductType = (currentProductType) => {
    return checkProductTypeEqual(currentProductType, [
        PRODUCT_TYPE_SCOOTERS_KEY,
        PRODUCT_TYPE_SCOOTER_KEY,
    ]);
};
export const checkMarineEngineProductType = (currentProductType) => {
    return checkProductTypeEqual(currentProductType, [
        PRODUCT_TYPE_MARINE_ENGINE_KEY,
        PRODUCT_TYPE_MARINE_ENGINES_KEY,
    ]);
};
